import { useEffect, useState } from 'react'
import { FilterProps } from '../../utils'
import { useGetLookupDisplayValue, useGetLookupResult } from '../../../../hooks/use-api'
import { Typeahead, TypeaheadOption } from '@msaf/core-react'
import { LookupDisplayValue, LookupResult } from '@msaf/generic-search-common'

export function FilterTypeahead({ filterKey, value, setValue, template, searchTypeKey, requestOptions }: FilterProps) {
  if (typeof value !== 'string') throw new Error('Invalid value type for `typeahead`')
  const [selectedOption, setSelectedOption] = useState<TypeaheadOption>({ label: '', value: '' })
  const [options, setOptions] = useState<Array<TypeaheadOption>>([])

  const { isLoading, isSuccess, data } = useGetLookupResult(
    {
      searchTypeKey,
      optionsKey: template.optionsKey,
      filter: '', // Fetch all options
    },
    requestOptions,
  )

  const {
    isLoading: isLoadingDisplayValue,
    isSuccess: isGotDisplayedValue,
    data: lookupDisplayValueData,
  } = useGetLookupDisplayValue(
    {
      searchTypeKey,
      optionsKey: template.optionsKey,
      internalValue: value,
    },
    requestOptions,
    !!value && typeof value === 'string',
  )

  useEffect(() => {
    if (isGotDisplayedValue && lookupDisplayValueData?.lookupDisplayValueResult?.displayValue) {
      const result = lookupDisplayValueData as LookupDisplayValue
      setSelectedOption({
        label: result.lookupDisplayValueResult.displayValue,
        value,
      })
    }
  }, [isGotDisplayedValue, lookupDisplayValueData, value])

  useEffect(() => {
    if (isSuccess && data?.lookupResult.rows) {
      const result = data as LookupResult
      const lookupOptions: Array<TypeaheadOption> = result.lookupResult.rows.map(
        ({ id: value, display_value: label }) => ({ label, value }),
      )
      setOptions(lookupOptions)
    }
  }, [isSuccess, data])

  const handleChange = (option: TypeaheadOption | null) => {
    if (option && Object.keys(option).length) {
      setValue(`${option.value}`)
      setSelectedOption(option)
    } else {
      setValue('')
      setSelectedOption({ label: '', value: '' })
    }
  }

  return (
    <div data-test-typeahead-selector className='generic-search-filter__input-text'>
      <Typeahead
        selectType='default'
        labelledBy={`search-filter-input-label-${filterKey}`}
        options={options}
        handleChange={handleChange}
        selectedOption={selectedOption}
        isSkeleton={isLoading || isLoadingDisplayValue}
      />
    </div>
  )
}
